import Lieferterminrechner from '../components/depv/Lieferterminrechner';

const DEPV_CHILDREN = {
	'8ca668c9-e4e6-4385-88f2-b53809448f77': <Lieferterminrechner />,
};


const useDynamicPageChildren = (context, uuid) => {
	switch(context) {
		case 'depv':
			return DEPV_CHILDREN[uuid] || null;
		default:
			return null;
	}
}

export default useDynamicPageChildren;
